export default class ChildParentContribution {

    static fromData(data) {
        if (!data) {
            return;
        }

        const contribution = new ChildParentContribution();
        contribution.dateFrom = data.dateFrom;
        contribution.parentIncomeOverall = data.parentIncomeOverall;
        contribution.childFirstname = data.childFirstname;
        contribution.childLastname = data.childLastname;
        contribution.fullname = data.childLastname + ', ' + data.childFirstname;
        contribution.externalId = data.externalId;
        contribution.dailyCareTime = data.dailyCareTime;
        contribution.dependentChildren = data.dependentChildren;
        contribution.parentContributionMonthly = data.parentContributionMonthly;
        contribution.foodCostMonthly = data.foodCostMonthly;
        contribution.otherCostMonthly = data.otherCostMonthly;
        contribution.subventionMonthly = data.subventionMonthly;
        contribution.costOverallMonthly = data.costOverallMonthly;
        contribution.name = data.name;
        contribution.textTop = data.textTop;
        contribution.textBottom = data.textBottom;
        contribution.error = data.error;

        return contribution;
    }
}
